module.exports = __webpack_public_path__ + "static/media/redTheme-girl.f725e5b0.svg";